export const environment = {
    production: true,
    baseURL: 'https://web.alarabiya.com.kw/api',
    frontendURL: 'https://alarabiya.com.kw/ar',
    catalogURL: 'https://web.alarabiya.com.kw/rest/ar/V1',
    base: 'https://adcommerce.alarabiya.com.kw/web/',
    baseAPI: 'https://web.alarabiya.com.kw/rest/ar/V1/',
    baseImagePath: 'pub/media/catalog/product/',
    baseCatalogUrl: 'https://web.alarabiya.com.kw/',
    tinymce_base: '/assets/tinymce/',
    googleMapsApi: 'AIzaSyC9xEHQk97ECj8VWG0dPSsI4E4V8SVMkDQ',
    defaultCountry: 'KW',
    baseAPI2:'https://adcommerce.alarabiya.com.kw/api/api',
    defaultCurrency:'KWD',
    cachedImagePath: 'pub/media/catalog/product/cache/89fe15788e0ddb13201fd7b32de9c9d8/',
    website_id: 1,
    store360link: "https://alarabiya.com.kw/360-tour",
    store_id:2
};

// export const environment = {
//     production: true,
//     baseURL: 'https://alarabiya.com.kw/api',
//     catalogURL: 'https://alarabiya.com.kw/rest/ar/V1',
//     base: 'https://adcommerce.alarabiya.com.kw/web/',
//     baseAPI: 'https://alarabiya.com.kw/rest/ar/V1/',
//     baseImagePath: 'pub/media/catalog/product/',
//     baseCatalogUrl: 'https://alarabiya.com.kw/',
//     tinymce_base: '/assets/tinymce/',
//     googleMapsApi: 'AIzaSyC9xEHQk97ECj8VWG0dPSsI4E4V8SVMkDQ',
//     defaultCountry: 'KW',
//     baseAPI2:'https://adcommerce.alarabiya.com.kw/api/',
//     defaultCurrency:'KWD',
//     website_id: 1,
//     store360link: "https://alarabiya.com.kw/tour3",
//     store_id: 2
// };
//baseURL: 'http://callcenter.cab.ps:7777/api/api'
//http://dev.supportcenter/api
